import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class GeneralKonstantsConverter implements JsonCustomConvert<GeneralKonstants>{
    serialize() { }
    deserialize(data: any): GeneralKonstants {
        switch (data) {
            case 'passpoint':
                {
                    return GeneralKonstants.Passpoint;
                }
            default:
                {
                    return GeneralKonstants.Passpoint
                }
        }
    }
}

export enum GeneralKonstants {
    Passpoint = 'passpoint',
}